import { ISchema } from '@formily/react'
import {VisibleControlSetter} from '../../../Formily/src/setters/components/VisibleControlSetter/index'

export const Box: ISchema = {
  type: 'object',
  properties: {
    'visibleControl': {
      title: '可见性控制',
      type: 'Object',
      'x-decorator': 'FormItem',
      'x-component': VisibleControlSetter,
    },
  },
}

